import React from 'react';
import useWorkplacePatient, {
	PatientData,
} from '../../../Hooks/useWorkplacePatient';
import { PatientManualRegistrationParams } from '../PatientManualRegistration';
import { useLazyUserParentsQuery } from '../../../../../graphql/graphql';
import PatientManualRegistrationSlovakiaForm, {
	PatientManualRegistrationSlovakiaFormValues,
} from './PatientManualRegistrationSlovakiaForm';
import useHelpers from '../../../../Base/Hooks/useHelpers';
import useFilters from '../../../../Base/Hooks/useFilters';
import { NCZICommandContextProvider } from '../../../../Nczi/Services/NCZICommandContext';
import { NCZIContextProvider } from '../../../../Nczi/Services/NCZIContext';

interface Props {
	workplaceId: string;
	onSuccess?: (params: PatientManualRegistrationParams) => void;
	setIsLoading: (isLoading: boolean) => void;
}
const PatientManualRegistrationSlovakia: React.FC<Props> = ({
	workplaceId,
	onSuccess,
	setIsLoading,
}) => {
	const { createPatient } = useWorkplacePatient();
	const { handleString } = useHelpers();
	const [getParents] = useLazyUserParentsQuery();
	const { handleDateValue } = useFilters();

	const handleSlovakiaRegistrationSuccess = async (
		values: PatientManualRegistrationSlovakiaFormValues,
		withHealthPlan: boolean,
	) => {
		setIsLoading(true);
		const data: PatientData = {
			sendEmailInvitation: values.sendPatientInviteToMeddi,
			patient: {
				salutationBefore: values.salutationBefore ?? undefined,
				salutationAfter: values.salutationAfter ?? undefined,
				firstName: values.firstName,
				lastName: values.lastName,
				address: values.address,
				insuranceCompanyTermItemId: handleString(
					values.healthInsuranceCompany?.value,
				),
				contactPhoneNumber: values.phoneNumber ?? undefined,
				contactEmail: handleString(values.email),
				insuranceNumber: values.insuranceNumber,
				birthDate: handleDateValue(values.birthDate),
				citizenship: handleString(values.citizenship?.value),
				gender: handleString(values.gender?.value),
			},
			legalRepresentative: values.legalRepresentative ?? undefined,
			healthPlanCode: handleString(values.healthPlanCode?.value),
			healthPlanWorkplaceMemberId:
				values.healthPlanWorkplaceMember?.value ??
				values.healthPlanWorkplaceMember?.id ??
				undefined,
			meta: {
				state: values.state?.value,
			},
			createdByType: handleString(values.createdByType?.value),
			createdById: values.createdById?.item?.user.id ?? undefined,
			ignoreInsuranceNumberCheck: values.ignoreInsuranceNumberCheck || false,
		};

		const response = await createPatient(data, workplaceId);
		if (response?.status === 200) {
			const patientData = response?.data;
			if (patientData) {
				let parentId = null;
				if (data.legalRepresentative) {
					const data = await getParents({
						id: patientData.userId,
					});
					if (data.data?.user?.parents?.[0]?.id) {
						parentId = data.data?.user?.parents?.[0].id;
					}
				}
				if (
					withHealthPlan &&
					patientData.userId &&
					data.healthPlanCode &&
					data.healthPlanWorkplaceMemberId
				) {
					//@ts-ignore
					window.location.href = `treatment/default/${patient.data.userId}?handle=createHealthPlan&params%5BhealthPlanCode%5D=${data.healthPlanCode}`;
					return;
				}
				onSuccess?.({
					patientId: patientData.userId,
					parentId: parentId,
					withInvite: !!(data.patient.contactEmail && data.sendEmailInvitation),
				});
			}
		}
		setIsLoading(false);
	};

	return (
		<NCZICommandContextProvider>
			<NCZIContextProvider>
				<PatientManualRegistrationSlovakiaForm
					onSuccess={handleSlovakiaRegistrationSuccess}
				/>
			</NCZIContextProvider>
		</NCZICommandContextProvider>
	);
};

export default PatientManualRegistrationSlovakia;
